import React from 'react';
import styles from './PriorityBadge.module.css';

interface PriorityBadgeProps {
  priority: 'HIGH' | 'MEDIUM' | 'LOW';
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => {
  const priorityClass = {
    HIGH: styles.high,
    MEDIUM: styles.medium,
    LOW: styles.low,
  }[priority];

  return (
    <span className={`${styles.badge} ${priorityClass}`}>
      {priority}
    </span>
  );
};
